// @flow
import JQueryView, {
  on,
  removeInvalidFeedback,
} from '../../../common/JQueryView';
import DateRangePicker from '../../../common/DateRangePicker';
import dayjs from 'dayjs';

declare var $: any;

export default class FormView extends JQueryView {
  specifyDeliveryTime: boolean;
  showException: boolean;
  showSpecifyDeliveryTimeException: boolean;

  constructor(
    specifyDeliveryTime: boolean,
    showException: boolean,
    showSpecifyDeliveryTimeException: boolean,
  ) {
    super('.simple_form');

    $('.form-group-float').each((index, element) => {
      const control = $(element).find('.form-control');
      if (control.val().length !== 0) {
        control.addClass('form-control-active');
      } else {
        control.removeClass('form-control-active');
      }
    });

    this.specifyDeliveryTime = specifyDeliveryTime;
    this.showException = showException;
    this.showSpecifyDeliveryTimeException = showSpecifyDeliveryTimeException;

    this.render();
  }

  @on({ event: 'blur', selector: '.form-control' })
  onBlurFormControl(event: any) {
    const target = $(event.target);
    if (target.hasClass('date-field') && $('.show-calendar').is(':visible')) {
      target.addClass('form-control-active');
      target.addClass('focus');
    } else {
      if (target.val().length === 0) {
        target.removeClass('form-control-active');
      } else {
        target.addClass('form-control-active');
      }
    }
  }

  @on({ event: 'change', selector: '.form-control' })
  onChangeFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length !== 0) {
      target.addClass('form-control-active');
      target.removeClass('is-invalid');
      removeInvalidFeedback(target);
      target.removeClass('focus');
    }
  }

  @on({ event: 'click' })
  onClickOtherArea(event: any) {
    if (!$(event.target).closest('.date-field').length) {
      $('.date-field').removeClass('focus');

      if ($('.date-field').val().length === 0) {
        $('.date-field').removeClass('form-control-active');
      }
    }
  }

  initDateRangePicker(container: any) {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        timePicker: true,
        timePicker24Hour: true,
        showDropdowns: true,
        minDate: dayjs(),
        locale: {
          format: 'YYYY/MM/DD HH:mm',
        },
        timePickerIncrement: 1,
      },
      {
        picker: {
          format: {
            start: 'YYYY/MM/DD HH:mm',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  }

  render() {
    this.initDateRangePicker(this.$el);
    if (
      !this.showSpecifyDeliveryTimeException &&
      (this.specifyDeliveryTime || this.showException)
    ) {
      $('.company_ir_scheduled_time').show();
      $('input[for="specify"]').prop('checked', true);
      $('input[for="not_specify"]').prop('checked', false);
    } else {
      $('.company_ir_scheduled_time').hide();
    }
  }

  @on({ event: 'click', selector: '#specify' })
  activateSpecifyDeliveryTime(event: Event) {
    const target = event.currentTarget;
    if ($(target).prop('checked')) {
      $('.company_ir_scheduled_time').show();
      $('input[for="not_specify"]').prop('checked', false);
    } else {
      $(target).prop('checked', true);
    }
  }

  @on({ event: 'click', selector: '#not_specify' })
  deactivateSpecifyDeliveryTime(event: Event) {
    const target = event.currentTarget;
    if ($(target).prop('checked')) {
      $('.company_ir_scheduled_time').hide();
      $('input[for="specify"]').prop('checked', false);
    } else {
      $(target).prop('checked', true);
    }
  }
}
